<template>
  <v-dialog v-model="dialogframeboton" persistent fullscreen>
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>{{ iconodialogbtn }}</v-icon> {{ titledialogbtn }} -
          Solicitud: {{ modelproceso.solicitud }}
        </v-toolbar-title>
        <v-toolbar-items>
          <v-btn
            class="d-none d-md-block"
            dark
            textn
            @click="dialogframeboton = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <!-- Consulta Documentos ¡-->
        <card-consultadocumentos
          v-if="componenteview == 1"
          :infollaves="llaves"
        ></card-consultadocumentos>
        <!-- Consulta Dato ¡-->
        <card-dato
          v-if="componenteview == 2"
          :NumeroSolicitud="modelproceso.solicitud"
          :ProcesoActual="campos.proceso"
        ></card-dato>
        <!-- Consulta  Estadistico ¡-->
        <card-consultaproceso
          v-if="componenteview == 3"
          :NumeroSolicitud="modelproceso.solicitud"
        ></card-consultaproceso>
        <!-- Trazabilidad ¡-->
        <card-traza
          v-if="componenteview == 4"
          :NumeroSolicitud="modelproceso.solicitud"
          :SistemaOrigen="'2'"
        ></card-traza>
      </v-card-text>
    </v-card>
  </v-dialog>
  <div align="center">
    <span v-if="!page">
      {{
        this.modelproceso.solicitud > 0
          ? "Solicitud  " + this.modelproceso.solicitud + "    "
          : ""
      }}
    </span>
    <span>
      {{
        campos != [] && campos != null
          ? campos.Desclinea + " - " + campos.Descproceso
          : ""
      }}
    </span>
  </div>
  <v-card
    :loading="progreso"
    :style="styleObject"
    :max-height="!collapsed ? '500' : '800'"
    class="overflow-y-auto"
  >
    <v-card-text>
      <div v-if="modelproceso.solicitud > 0" align="right">
        <!-- Consulta de documento  -->
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon @click="IconosSolicitud(1)" color="#05AD58" v-bind="props"
              >mdi-cloud-download</v-icon
            >
          </template>
          <span>Consulta de documentos</span>
        </v-tooltip>
        <v-divider class="mx-4" inset vertical></v-divider>
        <!-- Histórico de datos -->
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon @click="IconosSolicitud(2)" color="cyan" v-bind="props"
              >mdi-file-multiple-outline</v-icon
            >
          </template>
          <span>Histórico de datos</span>
        </v-tooltip>
        <v-divider class="mx-4" inset vertical></v-divider>
        <!-- Histórico de procesos -->
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon @click="IconosSolicitud(3)" color="red" v-bind="props"
              >mdi-folder-search-outline</v-icon
            >
          </template>
          <span>Histórico de procesos</span>
        </v-tooltip>
        <v-divider class="mx-4" inset vertical></v-divider>
        <!-- Trazabilidad -->
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon @click="IconosSolicitud(4)" color="cyan" v-bind="props"
              >mdi-chat-processing</v-icon
            >
          </template>
          <span>Trazabilidad</span>
        </v-tooltip>
      </div>
      <v-form autocomplete="off">
        <v-container
          v-if="
            campos != [] &&
            campos != null &&
            campos.Result != [] &&
            campos.Result != null
          "
          fluid
        >
          <v-row>
            <v-col
              v-for="(datos, i) in campos.Result"
              :key="i"
              cols="12"
              sm="12"
              :lg="datos.TipoDato === 20 || datos.TipoDato === 13 ? '12' : '6'"
            >
              <!-- Fechas-->
              <v-text-field
                v-if="datos.Visible && datos.Naturaleza == 'F'"
                type="date"
                v-model="datos.ValorFecha"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                @click:append-outer="AuditoriaDato(datos)"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorFecha),
                ]"
                @click="Fechas"
                :max="datos.Validacion_Estandar == 'A' ? FechaActual : ''"
                :min="datos.Validacion_Estandar == 'D' ? FechaActual : ''"
                :label="datos.Label"
                :readonly="datos.Protegido"
                onkeydown="return false"
                :clearable="datos.Protegido ? false : true"
              ></v-text-field>
              <!-- Hora -->
              <v-text-field
                v-else-if="
                  datos.Visible &&
                  datos.Naturaleza == 'A' &&
                  datos.TipoDato == 18
                "
                type="time" 
                v-model="datos.ValorAlfaNumerico"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                @click:append-outer="AuditoriaDato(datos)"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorAlfaNumerico),
                ]"
                :label="datos.Label"
                :readonly="datos.Protegido"
                :clearable="datos.Protegido ? false : true"
              ></v-text-field>
              <!-- textos grandes -->
              <v-textarea
                v-else-if="
                  datos.Visible &&
                  datos.TipoDato === 20 &&
                  datos.Naturaleza === 'A'
                "
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                @click:append-outer="AuditoriaDato(datos)"
                no-resize
                rows="10"
                :label="datos.Label"
                v-model="datos.ValorAlfaNumerico"
                :maxlength="datos.Tamanio"
                :counter="datos.Tamanio"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorAlfaNumerico),
                ]"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :readonly="datos.Protegido"
                :clearable="datos.Protegido ? false : true"
              >
              </v-textarea>
              <!-- Texto Numerico -->
              <v-text-field
                v-else-if="
                  datos.Visible &&
                  (datos.TipoDato === 1 || datos.TipoDato == 19) &&
                  datos.Naturaleza === 'N'
                "
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                @click:append-outer="AuditoriaDato(datos)"
                :label="datos.Label"
                type="tel"
                v-on:keypress="isNumber()"
                v-model="datos.ValorNumerico"
                :maxlength="datos.Tamanio"
                :counter="datos.Tamanio"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorNumerico),
                ]"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :readonly="datos.Protegido"
                :clearable="datos.Protegido ? false : true"
              ></v-text-field>
              <!-- Texto Alfanumerico -->
              <v-text-field
                v-else-if="
                  datos.Visible &&
                  (datos.TipoDato === 1 || datos.TipoDato == 19) &&
                  datos.Naturaleza === 'A'
                "
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                @click:append-outer="AuditoriaDato(datos)"
                :label="datos.Label"
                type="text"
                v-model="datos.ValorAlfaNumerico"
                :maxlength="datos.Tamanio"
                :counter="datos.Tamanio"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorAlfaNumerico),
                ]"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :readonly="datos.Protegido"
                :clearable="datos.Protegido ? false : true"
              >
              </v-text-field>
              <!-- Correo -->
              <v-text-field
                v-else-if="
                  datos.Visible &&
                  datos.TipoDato === 14 &&
                  datos.Naturaleza == 'A'
                "
                v-model="datos.ValorAlfaNumerico"
                :maxlength="datos.Tamanio"
                :counter="datos.Tamanio"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorAlfaNumerico),
                  rules.email(datos.ValorAlfaNumerico),
                ]"
                :readonly="datos.Protegido"
                :label="datos.Label"
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                :clearable="datos.Protegido ? false : true"
                @click:append-outer="AuditoriaDato(datos)"
              />
              <!--Digitado-Tabla Numérico-->
              <v-text-field
                v-else-if="
                  datos.Visible &&
                  datos.TipoDato === 12 &&
                  datos.Naturaleza === 'N'
                "
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                @click:append-outer="AuditoriaDato(datos)"
                :label="datos.Label"
                type="tel"
                v-on:keypress="isNumber()"
                v-model="datos.ValorNumerico"
                :maxlength="datos.Tamanio"
                :counter="datos.Tamanio"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorNumerico),
                ]"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :readonly="datos.Protegido"
                :clearable="datos.Protegido ? false : true"
                @keydown.enter="ValidateCampos"
                @keyup.enter="ValidateCampos"
              >
                <template v-slot:append>
                  <v-menu location="end">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" left> mdi-menu </v-icon>
                    </template>
                    <v-card min-width="300">
                      <span>Opciones</span>
                      <v-list>
                        <v-list-item
                          v-for="(item, z) in datos.TablaCombo"
                          :key="z"
                          :value="item"
                          active-color="red-darken-4"
                          link
                          @click="campos.Result[i].ValorNumerico = item.Valor"
                        >
                          <v-list-item-title
                            align="left"
                            v-text="item.Valor"
                          ></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-menu>
                </template>
              </v-text-field>
              <!--Digitado-Tabla Alfanumerico-->
              <v-text-field
                v-else-if="datos.Visible && datos.TipoDato === 12"
                :label="datos.Label"
                type="text"
                v-model="datos.ValorAlfaNumerico"
                :maxlength="datos.Tamanio"
                :counter="datos.Tamanio"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorAlfaNumerico),
                ]"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :readonly="datos.Protegido"
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                @click:append-outer="AuditoriaDato(datos)"
                :clearable="datos.Protegido ? false : true"
              >
                <template v-slot:append>
                  <v-menu location="end">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" left> mdi-menu </v-icon>
                    </template>
                    <v-card min-width="300">
                      <span>Opciones</span>
                      <v-list>
                        <v-list-item
                          v-for="(item, j) in datos.TablaCombo"
                          :key="j"
                          :value="item"
                          active-color="red-darken-4"
                          link
                          @click="
                            campos.Result[i].ValorAlfaNumerico = item.Valor
                          "
                        >
                          <v-list-item-title
                            align="left"
                            v-text="item.Valor"
                          ></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-menu>
                </template>
              </v-text-field>
              <!--Combo Numérico-->
              <v-autocomplete
                v-else-if="
                  datos.Visible &&
                  datos.TipoDato === 2 &&
                  datos.Naturaleza === 'N'
                "
                v-model="datos.ValorNumerico"
                :items="datos.TablaComboNumerico"
                color="blue-grey-lighten-2"
                item-title="Descripcion"
                item-value="Valor"
                :label="datos.Label"
                type="text"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorNumerico),
                ]"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :readonly="datos.Protegido"
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                :clearable="datos.Protegido ? false : true"
                @click:append-outer="AuditoriaDato(datos)"
              >
              </v-autocomplete>
              <!--Combo Alfanumérico-->
              <v-autocomplete
                v-else-if="
                  datos.Visible &&
                  datos.TipoDato === 2 &&
                  datos.Naturaleza === 'A'
                "
                v-model="datos.ValorAlfaNumerico"
                :items="datos.TablaCombo"
                color="blue-grey-lighten-2"
                item-title="Descripcion"
                item-value="Valor"
                :label="datos.Label"
                type="text"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorAlfaNumerico),
                ]"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :readonly="datos.Protegido"
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                :clearable="datos.Protegido ? false : true"
                @click:append-outer="AuditoriaDato(datos)"
              >
              </v-autocomplete>
              <!--Texto Protegidos Numerico-->
              <v-text-field
                v-else-if="
                  (datos.TipoDato === 3 ||
                    datos.TipoDato === 5 ||
                    datos.TipoDato === 6 ||
                    datos.TipoDato === 7 ||
                    datos.TipoDato === 8) &&
                  datos.Visible &&
                  datos.Naturaleza == 'N'
                "
                v-model="datos.ValorNumerico"
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                :label="datos.Label"
                @click:append-outer="AuditoriaDato(datos)"
                :suffix="datos.DescripcionTabla"
                :readonly="datos.Protegido"
              ></v-text-field>
              <!--Texto Protegidos AlfaNumerico-->
              <v-text-field
                v-else-if="
                  (datos.TipoDato === 3 ||
                    datos.TipoDato === 5 ||
                    datos.TipoDato === 6 ||
                    datos.TipoDato === 7 ||
                    datos.TipoDato === 8) &&
                  datos.Visible &&
                  datos.Naturaleza == 'A'
                "
                v-model="datos.ValorAlfaNumerico"
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                :label="datos.Label"
                @click:append-outer="AuditoriaDato(datos)"
                :suffix="datos.DescripcionTabla"
                :readonly="datos.Protegido"
              ></v-text-field>
              <!--Texto Protegidos Numerico-->
              <v-text-field
                v-else-if="
                  (datos.TipoDato === 3 ||
                    datos.TipoDato === 5 ||
                    datos.TipoDato === 6 ||
                    datos.TipoDato === 7 ||
                    datos.TipoDato === 8) &&
                  datos.Visible &&
                  datos.Naturaleza == 'F'
                "
                v-model="datos.ValorFecha"
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                :label="datos.Label"
                @click:append-outer="AuditoriaDato(datos)"
                :suffix="datos.DescripcionTabla"
                :readonly="datos.Protegido"
              ></v-text-field>
              <!--Titulo-->
              <div
                class="text-center"
                v-else-if="
                  datos.Visible &&
                  datos.TipoDato === 13 &&
                  datos.Naturaleza == 'A'
                "
              >
                <v-chip
                  label
                  color="teal"
                  text-color="white"
                  :value="datos.ValorAlfaNumerico"
                >
                  <v-avatar left>
                    <v-icon>mdi-head-lightbulb-outline</v-icon>
                  </v-avatar>
                  <b>
                    {{ datos.ValorAlfaNumerico }}
                  </b>
                </v-chip>
              </div>
              <!-- Direcciones -->
              <direcciones-modal
                v-else-if="
                  datos.Visible &&
                  (datos.TipoDato == 15 || datos.TipoDato == 16)
                "
                :infoCampo="datos"
              ></direcciones-modal>
              <!-- Asignacion Manual -->
              <asignacion-modal
                v-else-if="datos.Visible && datos.TipoDato == 17"
                :infoCampo.sync="datos"
                :dataIni.sync="modelproceso"
                :acceso="datos.ValorAlfaNumerico"
              ></asignacion-modal>
              <!-- Grupo Documentos -->
              <card-documentos
                v-else-if="
                  datos.Visible &&
                  (datos.TipoDato == 10 || datos.TipoDato == 11)
                "
                :infoCampo.sync="datos"
                :infollaves="llaves"
              ></card-documentos>
              <!-- Usuarios -->
              <v-autocomplete
                v-else-if="datos.Visible && datos.TipoDato == 21"
                v-model="datos.ValorAlfaNumerico"
                :items="ArrayUser"
                :item-title="
                  (ArrayUser) =>
                    ArrayUser.Usuario +
                    '-' +
                    ArrayUser.Nombre +
                    ' ' +
                    ArrayUser.Apellido
                "
                item-value="Usuario"
                color="primary"
                :label="datos.Label"
                type="text"
                :rules="[
                  rules.obligatorio(datos.Obligatorio, datos.ValorAlfaNumerico),
                ]"
                :hint="datos.MensajesAyuda"
                :error="datos.CampoFalta"
                :error-messages="datos.CampoFalta ? [datos.MensajeError] : ''"
                :readonly="datos.Protegido"
                :append-outer-icon="
                  datos.Auditoria === 'S' ? 'mdi-archive' : ''
                "
                :clearable="datos.Protegido ? false : true"
                @click:append-outer="AuditoriaDato(datos)"
              >
              </v-autocomplete>
              <!-- No encontrado 
              <v-label v-else>{{ datos }}</v-label> -->
            </v-col>
          </v-row>
          <div align="right">
            <v-btn
              v-if="!page"
              dark
              size="large"
              prepend-icon="mdi-note-plus"
              color="blue-grey-lighten-3"
              text
              @click="BtnSolBandeja"
              >Nuevo</v-btn
            >
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-btn
              dark
              size="large"
              prepend-icon="mdi-progress-check"
              color="red-darken-4"
              text
              @click="ValidateCampos"
              >Aceptar</v-btn
            >
          </div>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Asignacion from "@/views/TCI/ProcesosO/AutomatizacionProcesos/ComponentesProcesos/AsignacionManualModal.vue";
import Direcciones from "@/views/TCI/ProcesosO/AutomatizacionProcesos/ComponentesProcesos/DirectionModal.vue";
import ConsultProceso from "@/views/TCI/ProcesosO/ConsultaEstadistico/ConsultaEstadistico.vue";
import HistoricoDatos from "@/views/TCI/ProcesosO/HistoricoDatos/HistoricoDatos.vue";
import Trazabilidad from "@/views/TCI/Personas/Trazabilidad/Trazabilidad.vue";
import DocumentosComponents from "@/views/TCI/Documentos/DocumentosComponents/DocumentosComponents.vue";
import ConsultaDocumentos from "@/views/TCI/Documentos/ConsultaDocumentos/ConsultaDocumentos.vue";
import store from "@/store";
var M_interface = [];
export default {
  name: "construccion_pagina",
  components: {
    "direcciones-modal": Direcciones,
    "card-consultadocumentos": ConsultaDocumentos,
    "asignacion-modal": Asignacion,
    "card-consultaproceso": ConsultProceso,
    "card-dato": HistoricoDatos,
    "card-traza": Trazabilidad,
    "card-documentos": DocumentosComponents,
  },
  props: {
    infocabecera: {
      type: Object,
      default: [],
      Description: "Cabecera de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Se dispara desde el dialogo",
    },
  },
  data() {
    return {
      progreso: false,
      collapsed: true,
      ArrayUser: [],
      dialogframeboton: false,
      componenteview: "",
      iconodialogbtn: "",
      titledialogbtn: "",
      modelproceso: [
        {
          solicitud: 0,
          linea: 0,
          proceso: 0,
          dato: 0,
          RangoNumericoInferior: 0,
          RangoNumericoSuperior: 0,
          RangoAlfaNumericoInferior: "0",
          RangoAlfaNumericoSuperior: "0",
          secuencia: 0,
        },
      ],
      rules: {
        obligatorio(isRequired, v) {
          if (isRequired) {
            return !!v || "Este campo es obligatorio.";
          } else {
            return true;
          }
        },
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Email Inválido.";
        },
      },
      FechaActual: "",
      campos: null,
      styleObject: { border: "" },
      M_Reportes: [],
      M_Contenido: [],
      m_datos: [],
      llaves: {
        TypeDocument_ID: "",
        Document_ID: "",
        Primer_Apellido: "",
        Segundo_Apellido: "",
        Primer_Nombre: "",
        Segundo_Nombre: "",
        Solicitud: "",
        Contrato: "",
        Ref_1: "",
        Ref_2: "",
        Ref_3: "",
        Ref_4: "",
        Ref_5: "",
        IDServicio: "",
        IDPoliza: "",
        Secuencia_ID: "",
        EntradaReportes: {
          Reporte: 0,
          Origen: "S", // Sistema
          Parametros: [],
        },
      },
    };
  },
  methods: {
    onResize() {
      if (window.innerWidth > 1400) {
        this.collapsed = true;
      } else {
        this.collapsed = false;
      }
    },
    Fechas() {
      if (this.FechaActual == "") {
        this.FechaActual =
          this.$store.getters.userperfil.userInfo.FechasCierre.FechaProcesoActual.replace(
            "T00:00:00",
            "",
          );
      }
    },
    // Random de colores border
    createdcolor() {
      let randomNumber = 0;
      this.styleObject.border = "5px solid ";
      while (randomNumber == 0) {
        randomNumber = Math.floor(Math.random() * 12);
      }
      switch (randomNumber) {
        case 1:
          this.styleObject.border += "#B71C1C";
          break;
        case 2:
          this.styleObject.border += "#D50000";
          break;
        case 3:
          this.styleObject.border += "#686867";
          break;
        case 4:
          this.styleObject.border += "#BFBFBE";
          break;
        case 5:
          this.styleObject.border += "#EF9A9A";
          break;
        case 6:
          this.styleObject.border += "#546E7A";
          break;
        case 7:
          this.styleObject.border += "#6570E7";
          break;
        case 8:
          this.styleObject.border += "#78909C";
          break;
        case 9:
          this.styleObject.border += "#B6332E";
          break;
        case 10:
          this.styleObject.border += "#000";
          break;
        case 11:
          this.styleObject.border += "#FFF";
          break;
        default:
          this.styleObject.border += "#B6332E";
          break;
      }
    },
    // Es número
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // Consulta los procesos existentes para un usuario
    GetConstruccionPagina() {
      if (
        this.modelproceso.linea != "" &&
        this.modelproceso.linea != null &&
        this.modelproceso.linea > 0 &&
        this.modelproceso.proceso != "" &&
        this.modelproceso.proceso != null &&
        this.modelproceso.proceso > 0
      ) {
        this.progreso = true;
        var userperfil = this.$store.getters.userperfil;
        this.axios
          .get(
            "/Procesos/ConstruirPagina/getConstruirPagina/" +
              this.modelproceso.solicitud +
              "/" +
              this.modelproceso.linea +
              "/" +
              +this.modelproceso.proceso +
              "/" +
              this.modelproceso.dato +
              "/" +
              this.modelproceso.RangoNumericoInferior +
              "/" +
              this.modelproceso.RangoNumericoSuperior +
              "/" +
              this.modelproceso.RangoAlfaNumericoInferior +
              "/" +
              this.modelproceso.RangoAlfaNumericoSuperior +
              "/" +
              this.modelproceso.secuencia +
              "/" +
              userperfil.userInfo.Usuario_ID +
              "/" +
              userperfil.infoperfil.Perfil_ID,
          )
          .then((response) => {
            this.campos = response.data;
            if (this.campos.solicitud > 0) {
              this.llaves.Solicitud = this.campos.solicitud;
            }
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror = registro.Mensaje || registro.ExceptionMessage;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: mensajeerror,
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          })
          .finally(() => {
            this.progreso = false;
          });
      } else {
        this.$swal({
          icon: "warning",
          title: "No en contraron paramentros de página.",
          html: "No se encuentran parámetros de página, por favor revisar.",
        });
      }
    },
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      var dataquery = [];
      var listinterface = [];
      var listcontenidos = [];
      this.m_datos = [];
      this.M_Reportes = [];
      this.M_Contenido = [];

      M_interface = this.$store.getters.MIntefaceData;
      console.log(this.campos.Result);
      for (var i = 0; i < this.campos.Result.length; i++) {
        this.campos.Result[i].CampoFalta = false;
        if (this.campos.Result[i].Obligatorio) {
          switch (this.campos.Result[i].Naturaleza) {
            case "N":
              // Validamos que el campos sea mayor a 0
              if (
                this.campos.Result[i].ValorNumerico == 0 ||
                this.campos.Result[i].ValorNumerico == null
              ) {
                validate = true;
                this.campos.Result[i].CampoFalta = true;
              }
              break;
            case "F":
              if (
                this.campos.Result[i].ValorFecha == "1810-01-01" ||
                this.campos.Result[i].ValorFecha == "" ||
                this.campos.Result[i].ValorFecha == null
              ) {
                validate = true;
                this.campos.Result[i].CampoFalta = true;
              }
              break;
            case "A":
            case "T":
              switch (this.campos.Result[i].TipoDato) {
                //Valida correo
                case 14:
                  const pattern =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                  if (!pattern.test(this.campos.Result[i].ValorAlfaNumerico)) {
                    validate = true;
                    this.campos.Result[i].CampoFalta = true;
                  }
                  break;
                //Validación Asignación Manual
                case 17:
                  if (this.$store.getters.infoprocesodato != null) {
                    this.campos.Result[i].ValorAlfaNumerico =
                      this.$store.getters.infoprocesodato.ValorAlfaNumerico;
                    if (
                      this.campos.Result[i].ValorAlfaNumerico == "0" ||
                      this.campos.Result[i].ValorAlfaNumerico == "" ||
                      this.campos.Result[i].ValorAlfaNumerico == null
                    ) {
                      validate = true;
                      this.campos.Result[i].CampoFalta = true;
                    }
                  } else {
                    if (
                      this.campos.Result[i].ValorAlfaNumerico == "0" ||
                      this.campos.Result[i].ValorAlfaNumerico == "" ||
                      this.campos.Result[i].ValorAlfaNumerico == null
                    ) {
                      validate = true;
                      this.campos.Result[i].CampoFalta = true;
                    }
                  }
                  break;
                // Validacion Documento
                case 10:
                case 11:
                  if (this.$store.getters.infoprocesodato != null) {
                    this.campos.Result[i].ValorAlfaNumerico =
                      this.$store.getters.infodocumentpodato.ValorAlfaNumerico;
                    if (
                      this.campos.Result[i].ValorAlfaNumerico == "N" ||
                      this.campos.Result[i].ValorAlfaNumerico == "" ||
                      this.campos.Result[i].ValorAlfaNumerico == null
                    ) {
                      validate = true;
                      this.campos.Result[i].CampoFalta = true;
                    }
                  } else {
                    if (
                      this.campos.Result[i].ValorAlfaNumerico == "N" ||
                      this.campos.Result[i].ValorAlfaNumerico == "" ||
                      this.campos.Result[i].ValorAlfaNumerico == null
                    ) {
                      validate = true;
                      this.campos.Result[i].CampoFalta = true;
                    }
                  }
                  break;
                //Cualquier tipo que sea Alfanumerico
                default:
                  if (
                    this.campos.Result[i].ValorAlfaNumerico == "0" ||
                    this.campos.Result[i].ValorAlfaNumerico == "" ||
                    this.campos.Result[i].ValorAlfaNumerico == null
                  ) {
                    validate = true;
                    this.campos.Result[i].CampoFalta = true;
                  }
                  break;
              }
              break;
          }
        }
        if (this.campos.Result[i].DatoInterface == "S") {
          listinterface.push(this.campos.Result[i].Dato);
        }
        // Interface de contenidos
        await this.ContenidoReportes(i);
      }
      //Reporte_a_ejecutar

      if (listinterface.length > 0 && M_interface.length > 0) {
        for (var j in M_interface) {
          for (var i = 0; i < listinterface.length; i++) {
            var InfoInterface = M_interface[j].Datos.includes(listinterface[i]);
            if (InfoInterface) {
              dataquery = {
                Id_Interface: j,
                datowr: M_interface[j].DatoSearch,
                contenido: "",
                Obligatorio: M_interface[j].Obligatorio,
              };
              this.M_Reportes.push(dataquery);
              break;
            }
          }
        }
        var existe = false;
        /** Busco el contenido de los datos que necesitan las consultas en el vector VUE**/
        for (var j in this.M_Reportes) {
          var InfoContenido = this.M_Contenido.filter(
            (item) => item.dato_id == this.M_Reportes[j].datowr,
          );
          if (
            InfoContenido.length > 0 &&
            (!existe || this.M_Reportes[j].Obligatorio == "S")
          ) {
            this.M_Reportes[j].contenido = InfoContenido.contenido;
            var Pos = this.M_Reportes[j].Id_Interface;
            await this.getReporte(M_interface[Pos].ReporteId, Pos);
            existe = true;
          }
        }
      }
      // Consultas a Ejecutar
      //validate = true;
      if (!validate) {
        this.PostConstruccionPagina();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
      }
    },
    // Registro de guardar
    PostConstruccionPagina() {
      var userperfil = this.$store.getters.userperfil;
      var data = {
        Solicitud: this.modelproceso.solicitud,
        Linea: this.modelproceso.linea,
        Proceso: this.modelproceso.proceso,
        Campos: this.campos.Result,
        wllave: this.campos.wllave,
        Usuario: userperfil.userInfo.Usuario_ID,
        Perfil: userperfil.infoperfil.Perfil_ID,
      };
      this.progreso = true;
      this.axios
        .post("/Procesos/ActualizarSolicitudes/getlogicsolicitud/", data)
        .then((response) => {
          this.campos = response.data;
          if (this.campos.FinProceso) {
            this.$swal({
              icon: "success",
              title: "¡Finalizado!",
              html: this.campos.Mensaje,
            });
            if (!this.page) {
              this.campos = [];
              this.parametrospaginas();
            } else {
              var data = false;
              this.$emit("update:page", data);
            }
          } else {
            this.modelproceso.linea = this.campos.linea;
            this.modelproceso.proceso = this.campos.proceso;
            this.modelproceso.solicitud = this.campos.solicitud;
            this.llaves.Solicitud = this.modelproceso.solicitud;
            var VisibleCampo = false;
            for (var i = 0; i < this.campos.Result.length; i++) {
              if (this.campos.Result[i].Visible) {
                VisibleCampo = this.campos.Result[i].Visible;
                break;
              }
            }
            if (!VisibleCampo) {
              this.PostConstruccionPagina();
            }
          }
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Contenido Reportes
    async ContenidoReportes(indexvue) {
      var dataquery = {
        dato_id: 0,
        contenido: "",
      };
      if (this.campos.Result[indexvue].Naturaleza == "F") {
        if (
          this.campos.Result[indexvue].ValorFecha != "1810-01-01" &&
          this.campos.Result[indexvue].ValorFecha != "1910-01-01" &&
          this.campos.Result[indexvue].ValorFecha != "" &&
          this.campos.Result[indexvue].ValorFecha != null
        ) {
          dataquery = {
            dato_id: this.campos.Result[indexvue].Dato,
            contenido: this.campos.Result[indexvue].ValorFecha,
          };
          this.M_Contenido.push(dataquery);
        }
      } else if (this.campos.Result[indexvue].Naturaleza == "N") {
        if (
          this.campos.Result[indexvue].ValorNumerico != 0 &&
          this.campos.Result[indexvue].ValorNumerico != "" &&
          this.campos.Result[indexvue].ValorNumerico != null
        ) {
          dataquery = {
            dato_id: this.campos.Result[indexvue].Dato,
            contenido: this.campos.Result[indexvue].ValorNumerico,
          };
          this.M_Contenido.push(dataquery);
        }
      } else {
        if (
          this.campos.Result[indexvue].ValorAlfaNumerico != undefined &&
          this.campos.Result[indexvue].ValorAlfaNumerico != "" &&
          this.campos.Result[indexvue].ValorAlfaNumerico != null
        ) {
          dataquery = {
            dato_id: this.campos.Result[indexvue].Dato,
            contenido: this.campos.Result[indexvue].ValorAlfaNumerico,
          };
          this.M_Contenido.push(dataquery);
        }
      }
      if (this.campos.Result[indexvue].Campo_Relacionado > 0) {
        switch (this.campos.Result[indexvue].Campo_Relacionado) {
          case 1:
            this.llaves.TypeDocument_ID = String(
              this.campos.Result[indexvue].ValorNumerico,
            );
            break;
          case 2:
            this.llaves.Document_ID =
              this.campos.Result[indexvue].ValorAlfaNumerico;
            break;
          case 3:
            this.llaves.Primer_Apellido =
              this.campos.Result[indexvue].ValorAlfaNumerico;
            break;
          case 4:
            this.llaves.Segundo_Apellido =
              this.campos.Result[indexvue].ValorAlfaNumerico;
            break;
          case 5:
            this.llaves.Primer_Nombre =
              this.campos.Result[indexvue].ValorAlfaNumerico;
            break;
          case 6:
            this.llaves.Segundo_Nombre =
              this.campos.Result[indexvue].ValorAlfaNumerico;
            break;
          case 7:
            this.llaves.Solicitud = String(this.campos.solicitud);
            break;
          case 8:
            this.llaves.Contrato = this.campos.Result[indexvue].ValorNumerico;
            break;
          case 9:
            this.llaves.Ref_1 = this.campos.Result[indexvue].ValorAlfaNumerico;
            break;
          case 10:
            this.llaves.Ref_2 = this.campos.Result[indexvue].ValorAlfaNumerico;
            break;
          case 11:
            this.llaves.Ref_3 = this.campos.Result[indexvue].ValorAlfaNumerico;
            break;
          case 12:
            this.llaves.IDServicio = String(
              this.campos.Result[indexvue].ValorNumerico,
            );
            break;
          case 13:
            this.llaves.IDPoliza = String(
              this.campos.Result[indexvue].ValorNumerico,
            );
            break;
          case 14:
            this.llaves.Secuencia_ID = String(
              this.campos.Result[indexvue].ValorNumerico,
            );
            break;
          case 15:
            this.llaves.Ref_4 = this.campos.Result[indexvue].ValorAlfaNumerico;
            break;
          case 16:
            this.llaves.Ref_5 = this.campos.Result[indexvue].ValorAlfaNumerico;
            break;
        }
      }
    },
    // Consulta Reportes
    async getReporte(Reporte_ID, Pos) {
      this.llaves.EntradaReportes.Reporte = Reporte_ID;
      var data = this.llaves;
      this.axios
        .post("/reportes/generarreportes/", data)
        .then(async (result) => {
          this.m_datos = result.data;
          console.log(result.data);
          await this.Armo_M_informacion(Pos);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // Consulta armar matriz final de información
    async Armo_M_informacion(Posicion) {
      var wdato = 0;
      var posdato = 0;

      for (var j = 0; j < this.m_datos.DatosSalidaListResponse[0].length; j++) {
        wdato = M_interface[Posicion].Datos[j];
        for (var indexvue in this.campos.Result) {
          if (this.campos.Result[indexvue].Dato == wdato) {
            posdato = indexvue;
            break;
          }
        }
        for (var i = 0; i < this.m_datos.DatosSalidaListResponse.length; i++) {
          var registro = this.m_datos.DatosSalidaListResponse[i][j];
          if (registro != null && registro != "0" && registro != "") {
            await this.comboqueryvue(posdato, registro);
            await this.registroqueryvue(posdato, registro);
          }
        }
      }
    },
    // Devolver a VUE combo
    comboqueryvue(indexvue, registro) {
      var booldato = true;
      var datacombo = [];
      datacombo = {
        ValorInferior: "",
        ValorSuperior: "",
        value: "",
        range: "",
        text: "",
      };
      // Combo de datos Alfanumerico
      if (
        this.campos.Result[indexvue].TipoDato == 12 &&
        this.campos.Result[indexvue].Naturaleza == "A"
      ) {
        var valorexiste = this.campos.Result[indexvue].TablaCombo.filter(
          (item) => item.Valor == registro,
        );
        if (valorexiste.length == 0) {
          datacombo = {
            Valor: registro,
            Descripcion: registro,
          };
          this.campos.Result[indexvue].TablaCombo.push(datacombo);
          datacombo = [];
        }
      }
      // Combo de datos Numérico
      if (
        this.campos.Result[indexvue].TipoDato == 12 &&
        this.campos.Result[indexvue].Naturaleza == "N"
      ) {
        var valorexiste = this.campos.Result[
          indexvue
        ].TablaComboNumerico.filter((item) => item.Valor == registro);
        if (valorexiste.length == 0) {
          datacombo = {
            Valor: registro,
            Descripcion: registro,
          };
          this.campos.Result[indexvue].TablaComboNumerico.push(datacombo);
          datacombo = [];
        }
      }
    },
    // Devolver registro primero del contraro
    registroqueryvue(indexvue, registro) {
      if (this.campos.Result[indexvue].Naturaleza == "F") {
        //Fecha
        if (this.campos.Result[indexvue].Obligatorio) {
          if (
            this.campos.Result[indexvue].ValorFecha == "1810-01-01" ||
            this.campos.Result[indexvue].ValorFecha == "1910-01-01" ||
            this.campos.Result[indexvue].ValorFecha == "" ||
            this.campos.Result[indexvue].ValorFecha == null ||
            this.campos.Result[indexvue].ValorFecha == undefined
          ) {
            this.campos.Result[indexvue].ValorFecha = registro;
          }
        }
      } else if (this.campos.Result[indexvue].Naturaleza == "N") {
        //Numérico
        if (this.campos.Result[indexvue].Obligatorio) {
          if (
            this.campos.Result[indexvue].ValorNumerico == 0 ||
            this.campos.Result[indexvue].ValorNumerico == "" ||
            this.campos.Result[indexvue].ValorNumerico == null ||
            this.campos.Result[indexvue].ValorNumerico == undefined
          ) {
            this.campos.Result[indexvue].ValorNumerico = parseInt(registro);
          }
        }
      } else {
        //Alfanumérico
        if (this.campos.Result[indexvue].Obligatorio) {
          if (
            this.campos.Result[indexvue].ValorAlfaNumerico == undefined ||
            this.campos.Result[indexvue].ValorAlfaNumerico == "" ||
            this.campos.Result[indexvue].ValorAlfaNumerico == null
          ) {
            this.campos.Result[indexvue].ValorAlfaNumerico = registro;
          }
        }
      }
      this.campos.Result[indexvue].CampoFalta = false;
    },
    // Auditoría del dato
    AuditoriaDato(data) {
      this.auditoria = !this.auditoria;
      this.datoinfo = data;
    },
    // Botón de bandeja o nueva solicitud
    BtnSolBandeja() {
      this.m_datos = [];
      this.M_Reportes = [];
      this.M_Contenido = [];
      this.$store.commit("infodocumentpodato", null);
      this.$store.commit("infoprocesodato", null);
      if (!this.page) {
        this.parametrospaginas();
      }
    },
    IconosSolicitud(iconoelegido) {
      this.dialogframeboton = true;
      this.componenteview = iconoelegido;
      switch (iconoelegido) {
        case 1: // Consulta de documentos
          this.iconodialogbtn = "mdi-cloud-download";
          this.titledialogbtn = "Consulta de documentos";
          break;
        case 2: //Histórico de datos
          this.iconodialogbtn = "mdi-file-multiple-outline";
          this.titledialogbtn = "Histórico de datos";
          break;
        case 3: //Histórico de procesos
          this.iconodialogbtn = "mdi-folder-search-outline";
          this.titledialogbtn = "Histórico de procesos";
          break;
        case 4: //Trazabilidad
          this.iconodialogbtn = "mdi-chat-processing";
          this.titledialogbtn = "Trazabilidad";
          break;
      }
    },
    // Busca los parametros de la pagina
    async parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        this.modelproceso.linea = page.param1;
      }
      if (page.param2) {
        this.modelproceso.proceso = page.param2;
        this.modelproceso.dato = 0;
        this.modelproceso.solicitud = 0;
        this.modelproceso.RangoNumericoInferior = 0;
        this.modelproceso.RangoNumericoSuperior = 0;
        this.modelproceso.RangoAlfaNumericoInferior = "0";
        this.modelproceso.RangoAlfaNumericoSuperior = "0";
        this.modelproceso.secuencia = 0;
      }
      this.GetConstruccionPagina();
    },
  },
  mounted() {
    if (this.page) {
      this.modelproceso.linea = this.infocabecera.linea;
      this.modelproceso.proceso = this.infocabecera.proceso;
      this.modelproceso.solicitud = this.infocabecera.solicitud;
      this.llaves.Solicitud = this.modelproceso.solicitud;
      this.modelproceso.dato = 0;
      this.modelproceso.RangoNumericoInferior = 0;
      this.modelproceso.RangoNumericoSuperior = 0;
      this.modelproceso.RangoAlfaNumericoInferior = "0";
      this.modelproceso.RangoAlfaNumericoSuperior = "0";
      this.modelproceso.secuencia = 0;
      this.GetConstruccionPagina();
    } else {
      this.parametrospaginas();
    }

    var User = this.$store.getters.MUsers;
    this.ArrayUser = User;//.filter((item) => item.Usuario.includes("TCI"));

    this.createdcolor();
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
};
</script>
